import React, { Component } from 'react'

import fullSquare from '../../images/fullSquareMini.png'

import { Link } from 'react-router-dom'

import lifewise from '../../images/logo/lifewise.png'
import xgame from '../../images/logo/xgame.png'
import socium from '../../images/logo/socium.png'
import agehack from '../../images/logo/agehack.png'
import mendell from '../../images/logo/mendell.png'
import games from '../../images/logo/games.png'
import lottery from '../../images/logo/lottery.png'
import dragon from '../../images/logo/dragon.png'
import prover from '../../images/logo/prover.png'
import epassport from '../../images/logo/epassport.png'
import crowdfilming from '../../images/logo/crowdfilming.png'

export default class ViewProjects extends Component {
    constructor(props) {
        super(props)

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    render() {
        return (
            <div className="dashboard_right-panel">
                <div className="dashboard_right-panel_container">
                    <div className="item item_size_l">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${lifewise})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['LifeWise about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_blank" href="https://lifewise.cryptaur.com">
                                {this.translation['See catalog']}
                            </a>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_s">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${agehack})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['AgeHack allows you to monitor your health and receive the necessary recommendations in time to strengthen it']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <h1 className="item_thirdLine_coming-soon">
                                {this.translation['Coming soon']}
                            </h1>
                        </div>
                    </div>
                    <div className="item item_size_m">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${prover})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Prover about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_bank" href="https://prover.io">
                                {this.translation['Site']}
                            </a>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_m">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${crowdfilming})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Crowd Filming about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_bank" href="https://crowdfilming.io/">
                                {this.translation['Site']}
                            </a>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_s">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${dragon})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Etherdragons Arena about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_bank" href="https://game.etherdragons.world/cryptaur">
                                {this.translation['Play']}
                            </a>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_l">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${xgame})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['X-Game about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <h1 className="item_thirdLine_coming-soon">
                                {this.translation['Coming soon']}
                            </h1>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_s">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${mendell})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Mendel Chess about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_bank" href="https://chessmendel.cryptaur.com/">
                                {this.translation['Play']}
                            </a>
                        </div>
                    </div>
                    <div className="item item_size_l">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${games})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Games about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <a className="item_thirdLine_button" target="_blank" href="https://games.cryptaur.com">
                                {this.translation['Play']}
                            </a>
                            {/*<a className="item_thirdLine_link" href="#">*/}
                            {/*About*/}
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className="item item_size_l">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${epassport})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['EPassport about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <Link to={`/investor/settings`} className="item_thirdLine_button">{this.translation['Get into']}</Link>
                        </div>
                    </div>
                    <div className="item item_size_s">
                        <div
                            className="item_firstLine"
                            style={{ backgroundImage: `url(${socium})` }}
                        />
                        <div className="item_secondLine">
                            <p>
                                {this.translation['Socium about']}
                            </p>
                        </div>
                        <div className="item_thirdLine">
                            <h1 className="item_thirdLine_coming-soon">
                                {this.translation['Coming soon']}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
